export const en = {
    "revision-apply": "OK",
    "revision-draft-update": "Version moved to draft",
    "revision-from": "Version ",
    "revision-info": "This is a previously published version of your application. \nYou can make it active or copy it to a draft.",
    "revision-modal-title": "Activate the version from ",
    "revision-modal-content": "Are you sure you want to activate the version from {revisionDate}?\n Users who have already installed the current version of the application will not lose access to it until the application is reinstalled or a new version is published.",
    "revision-history": "Version History",
    "revision-hint": "If the application was previously published, you can either republish the old version or move the old version to draft.",
    "revision-make-active": "Make Active Version",
    "revision-move-to-draft": "Move to Draft",
    "revision-publish-error": "Version publication error",
    "revision-publish-success":"Version published",
} as const;
export const ru = {
    "revision-apply": "Применить",
    "revision-draft-update": "Версия перенесена в черновик",
    "revision-from": "Версия ",
    "revision-info": "Это уже опубликованная ранее версия вашего приложения. \nВы можете сделать ее активной или скопировать в черновик",
    "revision-modal-title": "Активация версии от ",
    "revision-modal-content": "Вы точно хотите сделать активной версию от {revisionDate}?\n Пользователи, которые уже установили текущую версию приложения, не потеряют к ней доступ, пока приложение не будет переустановлено или не будет опубликована новая версия.",
    "revision-history": "История версий",
    "revision-hint": "Если приложение публиковалось ранее, то можно опубликовать старую версию или перенести старую версию в черновик",
    "revision-make-active": "Сделать активной версией",
    "revision-move-to-draft": "Перенести в черновик",
    "revision-publish-error": "Ошибка публикации версии",
    "revision-publish-success": "Версия опубликована",
} as const;
